module.exports = __webpack_public_path__ + "img/x-icon3.507928b2.png";